// eslint-disable-next-line import/no-cycle
import axios from '@/core/plugins/axios';

const baseUrl = import.meta.env.VITE_API_STORIES;
const headers = {
  'Content-Type': 'application/json; Charset=UTF-8',
};

export default {
  getAuthors(options = null) {
    let params = null;

    if (options) {
      const {
        offset = 0,
        limit = 10,
        keyword = '',
        type = '',
        sort = '',
      } = options;

      params = {
        offset,
        fetchLimit: limit,
        search: keyword,
      };

      if (sort) {
        params.sortColumns = type;
        params.sortColumnOrders = sort;
      }
    }

    return axios({
      method: 'get',
      url: `${baseUrl}/authors`,
      headers,
      params,
    });
  },
  getAuthor(id) {
    const params = {
      authorId: id,
    };

    return axios({
      method: 'get',
      url: `${baseUrl}/author`,
      headers,
      params,
    });
  },
  createAuthor(data) {
    return axios({
      method: 'post',
      url: `${baseUrl}/author`,
      headers,
      data,
    });
  },
  updateAuthor(data) {
    return axios({
      method: 'put',
      url: `${baseUrl}/author`,
      headers,
      data,
    });
  },
  deleteAuthor(id) {
    const params = {
      authorId: id,
    };

    return axios({
      method: 'delete',
      url: `${baseUrl}/author`,
      headers,
      params,
    });
  },
};
